import React from 'react';
import { Box } from '@mui/material';

import BG from '@images/maintenance.png';

const Maintenance = () => (
  <Box
    height="100vh"
    style={{
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundImage: `url(${BG})`,
    }}
  />
);

export default Maintenance;
